export const currencyFormatter = (value = "", symbol) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const suffix = symbol === "" ? symbol : ` ${symbol}`;
  const number =
    typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isFinite(number)) {
    // not a plain number (e.g. already formatted): group digits as before
    return `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${suffix}`;
  }
  return `${number.toLocaleString("en-US", {
    maximumFractionDigits: 2,
  })}${suffix}`;
};
